import React from "react";
import { NavLink } from "react-router-dom";
import NavDropdown from "react-bootstrap/NavDropdown";
import RightsCheck from "../General/RightsCheck";
import { scrollToTop } from "../Shared/ScrollOnTop";

const TransportMenu = () => {
  return (
    <>
      <RightsCheck />
      <nav className={`navbar navbar-expand-lg navbar-module MenuSticky`}>
        <div className="container-fluid">
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#TransportNavbar"
            aria-controls="TransportNavbar"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="TransportNavbar">
            <ul className="navbar-nav m-auto">
              <li className="nav-item">
                <NavLink
                  onClick={scrollToTop}
                  className="nav-link"
                  to="/Transport/TransportDashboard"
                >
                  Dashboard
                </NavLink>
              </li>
              <li className="nav-item">
                <NavDropdown title="Reports">
                  <NavLink
                    onClick={scrollToTop}
                    className="dropdown-item"
                    to="/Transport/RoutesReport"
                  >
                    Routes Report
                  </NavLink>
                </NavDropdown>
              </li>
              <li className="nav-item">
                <NavDropdown title="Setup">
                  <NavLink
                    onClick={scrollToTop}
                    className="dropdown-item"
                    to="/Transport/ManageBusRoutes"
                  >
                    Manage Bus Routes
                  </NavLink>
                  <NavLink
                    onClick={scrollToTop}
                    className="dropdown-item"
                    to="/Transport/ManageRouteSections"
                  >
                    Route Sections
                  </NavLink>
                </NavDropdown>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
};

export default TransportMenu;
